import { apiCallJson } from "../Helpers";
import { ApiErrors } from "../Constants";

export async function validateAndRefreshTokens() {

    var refreshToken = localStorage.getItem('refreshToken');

    if (refreshToken !== null) {

        var data = await apiCallJson(
            '/account/token/refresh',
            'POST',
            { refreshToken: refreshToken },
        );

        if (data.success) {
            if (window.ACTIVATE_LOGS){console.log('Tokens refreshed')}
            localStorage.setItem('accessToken', data.data.accessToken);
            localStorage.setItem('refreshToken', data.data.refreshToken);
            return true;
        } else {
            if(data.errors.some((x) => x.errorType == ApiErrors.DateExpired)){
                sessionStorage.setItem("dateExpired", true);
            }
            return false;
        }

    } else {
        if (window.ACTIVATE_LOGS){console.log('No tokens storeds')}
        return false;
    }

}